import React, { useEffect, useState } from 'react';
import './leaders-stats.css';
import Tippy from '@tippyjs/react';


let leaders = []

let relicsById = {}
let leadersById = {};

let stats = undefined;
let leaderStats = undefined;

const leaderMappings = {
    "PowerActionPrototypeUnitTarget": "Unit Target",
    "PowerActionPrototypeNoTarget": "No Target",
};

function useMediaQuery(query) {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
    useEffect(() => {
        const mq = window.matchMedia(query);
        const handler = e => setMatches(e.matches);
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, [query]);
    return matches;
};

const LeadersStats = () => {
    const [message, setMessage] = useState('Loading leaders...');
    const [leaderList, setLeaderList] = useState(leaders);

    const isMobile = useMediaQuery('(max-width: 600px)');

    useEffect(() => {
        if (leaders.length > 0) {
            setMessage(null);
            setLeaderList(leaders);
            return;
        }

        const relicsUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/relics.json`;
        const leadersUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/leaders.json`;
        const statsUrl = `${process.env.REACT_APP_ASSETS_URL}/assets/stats.json`;

        Promise.all([
            // fetch(relicsUrl).then(res => {
            //     if (!res.ok) throw new Error('Fetch relics failed');
            //     return res.json();
            // }),
            fetch(leadersUrl).then(res => {
                if (!res.ok) throw new Error('Fetch leaders failed');
                return res.json();
            }),
            // fetch(statsUrl).then(res => {
            //     const json = (res.headers.get('content-type') ?? '').includes('application/json');
            //     if (!res.ok || !json) return {};
            //     return res.json();
            // })
        ])
        .then(results => {
            // [relicsById, leadersById, stats] = results;
            [leadersById] = results;

            // leaderStats = stats.leaderStats != undefined ? stats.leaderStats.reduce((acc, leader) => {
            //     acc[leader.leaderId] = leader.leaderRelicStats;
            //     return acc
            // }, {}) : undefined;

            leaders = Object
                .values(leadersById)
                .filter(leader => leader.enabled == undefined || leader.enabled == true)
                .sort((l1, l2) => l1.name.localeCompare(l2.name));
            if (!leaders.find(leader => leader.idString == 'Cleopatra')) {
                leaders.push({
                    id: 0,
                    idString: 'Cleopatra',
                    name: 'Cleopatra',
                    icon: 'assets/leaders/Cleopatra.png',
                    powers: [],
                    description: 'Coming soon...',
                })
            }
            if (!leaders.find(leader => leader.idString == 'Harambe')) {
                leaders.push({
                    id: 0,
                    idString: 'Harambe',
                    name: 'Harambe',
                    icon: 'assets/leaders/Harambe.png',
                    powers: [],
                    description: 'Coming soon...',
                })
            }
            setMessage(null);
            setLeaderList(leaders);
        })
        .catch(err => {
            setMessage('Failed to load leaders');
            console.error("Error fetching or processing JSON:", err.message);
        });
    }, []);

    const [tooltipFilters, setTooltipFilters] = useState([
        { name: 'Simple', type: 'simple', selected: true },
        { name: 'Advanced', type: 'advanced', selected: false },
    ]);

    const handleTooltipFilterClick = (index) => {
        const newFilters = tooltipFilters.map((filter, i) => ({
            ...filter,
            selected: i === index,
        }));
        setTooltipFilters(newFilters);
        const filter = newFilters.find(filter => filter.selected);
        const relicList = document.querySelector('.leader-list');
        if (filter.type == 'simple') {
            relicList.classList.remove('advanced-tooltips');
        }
        if (filter.type == 'advanced') {
            relicList.classList.add('advanced-tooltips');
        }
    };
    
    return (
        <article className="App-page leaders-page">
            <h1>Leaders</h1>

            <section className="relics-filter">
                <div className="relics-filter-group">
                    <span className="relics-filter-group-title">Tooltips:</span>
                    <ul>
                        {tooltipFilters.map((filter, index) => (
                            <li key={ `tooltips-${index}` } onClick={() => handleTooltipFilterClick(index)} className={filter.selected ? 'selected' : ''}>{filter.name}</li>
                        ))}
                    </ul>
                </div>
            </section>

            {message ? (
                <p>{message}</p>
            ) : (
                <div>
                    <ul className="leader-list">
                        {leaderList.map((leader) => {
                            return (
                                <li key={ leader.name }>
                                    <figure className="leader-thumbnail">
                                        <Tippy
                                            placement={isMobile ? 'bottom' : 'auto'}
                                            // animation="scale"
                                            duration="0"
                                            popperOptions={isMobile ? {
                                                modifiers: [{ name: 'flip', enabled: false }]
                                            } : undefined}
                                            content={(
                                                <article className="leader">
                                                    <div className="leader-content">
                                                        <main className="leader-main">
                                                            {leader.description != undefined ? (
                                                                <p>{ leader.description }</p>
                                                            ): "" }
                                                            <section className="leader-powers">

                                                                {leader.powers.map((power) => {
                                                                    return (
                                                                        <section className="power">
                                                                            <section className="power-header">
                                                                                <img className="power-icon" src={ `${process.env.REACT_APP_ASSETS_URL}/${power.icon}` } alt={ power.name } />
                                                                                <div className="power-name">{ power.name }</div>
                                                                            </section>
                                                                            <section className="power-info">
                                                                                <ul>
                                                                                    <li key="action">
                                                                                        <div className="key">Type</div>
                                                                                        <div className="value">{ leaderMappings[power.action?.tag] ?? 'Passive' }</div>
                                                                                    </li>
                                                                                </ul>
                                                                            </section>
                                                                            <section className="power-description">
                                                                                <p dangerouslySetInnerHTML={{ __html: power.description.replace(/\r?\n/g, '<br>') }}/>
                                                                            </section>
                                                                            <section className="power-simpleDescription">
                                                                                <p dangerouslySetInnerHTML={{ __html: power.simpleDescription?.replace(/\r?\n/g, '<br>') }}/>
                                                                            </section>
                                                                            {power.values.length > 0 ? (
                                                                                <section className="power-values">
                                                                                    <ul>
                                                                                        {Object.entries(power.values).map(([key, value]) => (
                                                                                            <li key={key}>
                                                                                                <div className="key">{ value.title }</div>
                                                                                                <div className="value" dangerouslySetInnerHTML={{ __html: value.description }}></div>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </section>
                                                                            ): "" }
                                                                            {power.milestones.length > 0 ? (
                                                                                <section className="power-milestones">
                                                                                    {Object.values(power.milestones).map((milestone) => {
                                                                                        return (
                                                                                            <div className="power-milestone">
                                                                                                <div className="power-milestone-title">{ milestone.title }</div>
                                                                                                <div className="power-milestone-description" dangerouslySetInnerHTML={{ __html: milestone.description?.replace(/\r?\n/g, '<br>') }}/>
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </section>
                                                                            ): "" }
                                                                            {power.action?.val?.cooldown ? (
                                                                                <section className="power-stats">
                                                                                <div className="power-stats-value">
                                                                                    <img src="cooldown.png" alt="Cooldown" title="Cooldown"/>
                                                                                    <span>{power.action.val.cooldown}</span>
                                                                                </div>
                                                                                </section>
                                                                            ) : "" }
                                                                        </section>
                                                                    )
                                                                })}
                                                            </section>
                                                        </main>
                                                    </div>
                                                    {leaderStats != null ? (
                                                        <aside className="leader-aside">
                                                            <div className="leader-aside-title">Popular Relics (patch: { stats.patch })</div>
                                                            <ul className="leader-aside-leaders">
                                                                {Object.entries(leaderStats[leader.id] ?? {}).slice(0, 5).map(([leaderId, relicStat]) => {
                                                                    const relic = relicsById[relicStat.relicId];
                                                                    return (
                                                                        <li key={ `relic-${relicStat.relicId}` }>
                                                                            <figure className="leader-aside-leader-image">
                                                                                <img src={ `${process.env.REACT_APP_ASSETS_URL}/${relic?.icon}` } alt=""/>
                                                                            </figure>
                                                                            <div className="leader-aside-values">
                                                                                <div>
                                                                                    <span className="key">Picks: </span>
                                                                                    <span className="value">{ relicStat.picks ?? '0' }</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="key">Win Rate: </span>
                                                                                    <span className="value">{ relicStat.winRate != undefined ? (relicStat.winRate * 100).toFixed(2) + '%' : '-' }</span>
                                                                                </div>
                                                                                <div>
                                                                                    <span className="key">Top 4 Rate: </span>
                                                                                    <span className="value">{ relicStat.top4Rate != undefined ? (relicStat.top4Rate * 100).toFixed(2) + '%' : '-' }</span>
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                })}
                                                            </ul>
                                                        </aside>
                                                    ) : "" }
                                                </article>
                                            )}>
                                            <button className="leader-icon">
                                                <div class="leader-portrait">
                                                    <img src={ `${process.env.REACT_APP_ASSETS_URL}/${leader.icon}` } alt={ leader.name } />
                                                </div>
                                                <div className="leader-ribbon">
                                                    <span>{ leader.name }</span>
                                                </div>
                                                <div className="leader-bottom"></div>
                                                <div className="leader-background"></div>
                                            </button>
                                        </Tippy>
                                    </figure>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
        </article>
    );
};

export default LeadersStats;
